import React, { type ReactNode } from 'react'
import classNames from 'classnames'
import styles from './RadioCard.module.scss'

export interface RadioCardProps {
  id: string
  name: string
  value: string
  checked: boolean
  disabled?: boolean
  label: string
  description?: ReactNode
  warning?: ReactNode
  onChange: (value: string) => void
}

export const RadioCard: React.FC<RadioCardProps> = ({ id, name, value, checked, disabled, label, description, warning, onChange }) => (
  <label
    htmlFor={id}
    className={classNames(styles.row, 'd-flex align-items-center gap-3 w-100', {
      [styles['row--selected']]: checked,
    })}
  >
    <div className='flex-grow-1'>
      <div className='fw-semibold small'>{label}</div>
      {checked && warning ? warning : description ? <div className='text-muted small'>{description}</div> : null}
    </div>
    <input
      type='radio'
      id={id}
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={() => onChange(value)}
      className='form-check-input flex-shrink-0'
    />
  </label>
)
